import { useCallback, useEffect, useState } from "react";

import * as Sentry from "@sentry/react";
import { StripeError } from "@stripe/stripe-js";

import * as BillingUtils from "@app/analytics/account/Billing/utils";

const useStripeLoadFailed = () => {
  const [stripeLoadFailed, setStripeLoadFailed] = useState(false);

  const onStripeLoadFailed = useCallback(
    (event: { elementType: "payment" | "address"; error: StripeError }) => {
      if (event) {
        BillingUtils.handleLoadError(event);
      }
      setStripeLoadFailed(true);
    },
    []
  );

  useEffect(() => {
    if (window.READ_STRIPE_ERROR_PROMISE) {
      window.READ_STRIPE_ERROR_PROMISE.then(() =>
        setStripeLoadFailed(false)
      ).catch(() => {
        Sentry.captureMessage("Stripe Error: Load failed during checkout");
        setStripeLoadFailed(true);
      });
    }
  }, []);

  return { stripeLoadFailed, onStripeLoadFailed };
};

export default useStripeLoadFailed;
